<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title flex between">
      <span>医生标签详情</span>
      <el-button
        type="primary"
        style="width:92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <span>标签名：</span>
          <span class="label_name">{{label_name}}</span>
          <span>标签类别：</span>
          <span class="label_name">{{label_type_name}}</span>
        </div>
        <div class="searchbox">
          <div class="flex">
            <div class="item">
              <span>医生姓名</span>
              <el-input
                v-model="doctor_name"
                clearable
                @change="search"
                style="width:160px;margin:0 16px 0 6px"
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机号</span>
              <el-input
                v-model="phone"
                clearable
                @change="search"
                style="width:160px;margin:0 16px 0 6px"
              ></el-input>
            </div>
            <div class="item">
              <el-button
                type="info"
                style="background-color: #eceff2; color: #747981;"
                @click="search"
              >查询</el-button>
            </div>
          </div>
          <el-button
            type="primary"
            :disabled=" module_id_array[0] ? !module_id_array.includes('1358') : false"
            @click="addDoctorBtn"
          >添加医生到当前标签</el-button>
        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="医生姓名">
              <template slot-scope="scope">
                <span
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >{{ scope.row.doctor_name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="手机号"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="医院名称"
              prop="hospital"
            ></el-table-column>
            <el-table-column
              label="科室"
              prop="department_name"
            ></el-table-column>
            <el-table-column
              label="职称"
              prop="title"
            ></el-table-column>
            <el-table-column label="医生所在省市">
              <template slot-scope="scope">
                <span>{{scope.row.province_name}}{{scope.row.city_name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled=" module_id_array[0] ? !module_id_array.includes('1357') : false"
                  @click="delDoctor(scope.row.doctor_id)"
                >从当前标签移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0;text-align:center"
          ></el-pagination>
        </div>
        <!-- 选择医生弹框 -->
        <choose-doctor
          :recommendDoctorTableDia.sync="recommendDoctorTableDia"
          @confirmDoctor="confirmDoctor"
        ></choose-doctor>
      </div>
    </div>
  </div>
</template>
<script>
import DocMsg from '../../../components/common/DocMsg.vue';
import ChooseDoctor from '@/components/chooseDoctor/index';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      phone: '',
      doctorId: '',
      doc_msg: false,
      doctorId: '',
      recommendDoctorTableDia: false,
      label_id: '',
      label_name: '',
      label_type_name: ''
    };
  },
  components: {
    DocMsg,
    ChooseDoctor
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        label_id: this.label_id,
        doctor_name: this.doctor_name,
        phone: this.phone
      };
      this.axios
        .post('platform/Doctor/getDoctorLabelDetail', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    addDoctorBtn() {
      this.recommendDoctorTableDia = true;
    },
    confirmDoctor(data) {
      let doctor_arr = data.map((item) => item.doctor_id);
      let addData = {
        doctor_id: doctor_arr.toString(),
        label_id: this.label_id
      };
      this.axios.post('platform/Doctor/addLabelDoctor', addData).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功');
          this.getList();
        }
      });
    },
    //删除
    delDoctor(doctor_id) {
      this.$confirm('您确定从当前标签移除当前医生吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            doctor_id,
            label_id: this.label_id
          };
          this.axios
            .post('platform/Doctor/removeLabelDoctor', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                if (!(this.tableData.length - 1) % this.pagesize) {
                  this.currentPage =
                    this.currentPage == 1 ? 1 : this.currentPage - 1;
                }
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    back() {
      history.back();
    }
  },
  activated() {
    let data = this.$route.query;
    this.label_id = data.label_id;
    this.label_name = data.label_name;
    this.label_type_name = data.label_type_name;
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  align-items: center;
  margin: 20px 0;
  justify-content: space-between;
  .item {
    display: flex;
    align-items: center;
  }
}
.label_name {
  font-size: 15px;
  font-weight: 700;
  margin: 0 40px 0 6px;
}
</style>
